import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import taxService from "../../services/taxService";

/**
 * Initial state for the tax slice
 */
const initialState = {
  taxRate: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

/**
 * Async thunk for getting default tax rate
 */
export const getDefaultTaxRate = createAsyncThunk(
  "tax/getDefault",
  async (_, thunkAPI) => {
    try {
      return await taxService.getDefaultTaxRate();
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

/**
 * Async thunk for updating default tax rate
 */
export const updateDefaultTaxRate = createAsyncThunk(
  "tax/updateDefault",
  async (taxRateData, thunkAPI) => {
    try {
      return await taxService.updateDefaultTaxRate(taxRateData);
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

/**
 * Async thunk for calculating tax
 */
export const calculateTax = createAsyncThunk(
  "tax/calculate",
  async (params, thunkAPI) => {
    try {
      return await taxService.calculateTax(params);
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

/**
 * Tax slice with reducers and extra reducers for async actions
 */
export const taxSlice = createSlice({
  name: "tax",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get default tax rate
      .addCase(getDefaultTaxRate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDefaultTaxRate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.taxRate = action.payload;
      })
      .addCase(getDefaultTaxRate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Update default tax rate
      .addCase(updateDefaultTaxRate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateDefaultTaxRate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.taxRate = action.payload;
      })
      .addCase(updateDefaultTaxRate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Calculate tax
      .addCase(calculateTax.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(calculateTax.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(calculateTax.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = taxSlice.actions;
export default taxSlice.reducer;
